import { render, staticRenderFns } from "./MyDealers.vue?vue&type=template&id=b0c821b0"
import script from "./MyDealers.vue?vue&type=script&lang=js"
export * from "./MyDealers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports